import React, { useEffect } from "react";
import renderSelectField from "../../shared/components/form/Select";
import { Field } from "redux-form";
import { connect } from "react-redux";
import {
  getAllIssuerConfigs,
  resetConfigs
} from "./actions/issuerConfig.actions";
import { Alert, Spinner } from "reactstrap";
import { MdRefresh } from "react-icons/md";
import { permissionsConstants } from "../../constants/permissions.constants";

const ConfigurationDropDown = props => {
  const {
    issuerConfigs,
    permissions,
    assignedIssuer,
    label,
    dispatch,
    onChange,
    disabled,
    id,
    required
  } = props;

  let userPermissions = permissions;

  userPermissions =
    userPermissions && userPermissions.map(permission => permission.authority);

  const isAdmin =
    userPermissions &&
    userPermissions.includes(permissionsConstants.FETCH_ISSUER_CONFIGS);

  const issuer = isAdmin ? "" : assignedIssuer;

  const loadConfigs = () => {
    dispatch(getAllIssuerConfigs(issuer));
  };

  useEffect(() => {
    const loadConfigs = () => {
      dispatch(getAllIssuerConfigs(issuer));
    };
    if (!isAdmin) {
      loadConfigs();
    } else {
      dispatch(resetConfigs());
    }
    return () => dispatch(resetConfigs());
  }, [issuer, isAdmin, dispatch]);

  return (
    
    <div className="form__form-group">
      <span className={`form__form-group-label ${required ? "required" : ""}`}>
        {label}
      </span>
      <div className="form__form-group-field">
        <Field
          id={id}
          name="configName"
          disabled={disabled}
          customChange={onChange}
          component={renderSelectField}
          options={
            issuerConfigs && issuerConfigs.response
              ? issuerConfigs.response.content
              : []
          }
          valueKey="name"
          labelKey="name"
        />
      </div>
      {issuerConfigs && issuerConfigs.error ? (
        <Alert color="danger">
          Could not fetch configurations
          {issuerConfigs.loading ? (
            <Spinner className="float-right" size="sm" color="danger" />
          ) : (
            <MdRefresh
              onClick={loadConfigs}
              className="float-right pointer"
              size={20}
            />
          )}
        </Alert>
      ) : null}
    </div>
  );
};

export default connect(state => ({
  issuerConfigs: state.getAllIssuerConfig,
  permissions: state.permissions && state.permissions.response,
  assignedIssuer:
    state.getIssuerDomainMapping &&
    state.getIssuerDomainMapping.response &&
    state.getIssuerDomainMapping.response.data
      ? state.getIssuerDomainMapping.response.data[0]
      : []
}))(ConfigurationDropDown);
